import { LinkBoxList, Main } from 'ui/components';
import { ModuleMapFeature } from 'features/Mappers/Module';
import { GlobalArticleContentFeature } from 'features/Modules';
import { useDynamicNavigationLinks } from '../shared/useDynamicNavigationLinks';

export const GlobalArticlePagePageFeature: React.FC<Umbraco.GlobalArticlePage> = ({ properties }) => {
	const { pageHeader, pageSections, pageSettings, globalArticleContent, globalArticleWidth } = properties ?? {};
	const { useDynamicNavigation, dynamicLinks, heading } = useDynamicNavigationLinks(pageSettings);
	const lastSection = pageSections?.[pageSections.length - 1];
	const linkBoxSectionWidth = lastSection?.settings?.properties?.width || globalArticleWidth || 'Small';

	const globalArticleObj = { ...globalArticleContent, globalArticleWidth };

	return (
		<Main
			header={pageHeader?.map((headerModule, index) => (
				<ModuleMapFeature key={index} contentModule={headerModule} />
			))}
			className="GlobalArticlePage"
			width={!globalArticleWidth ? 'Small' : globalArticleWidth}
		>
			<GlobalArticleContentFeature {...globalArticleObj} />
			{pageSections &&
				pageSections?.map((sectionModule, index) => (
					<ModuleMapFeature key={index} contentModule={sectionModule} width={globalArticleWidth} />
				))}

			{useDynamicNavigation && dynamicLinks.length > 0 && (
				<LinkBoxList
					items={[{ heading, links: dynamicLinks, variant: 'inline' }]}
					desktopWidth="100"
					mobileWidth="100"
					containerWidth={linkBoxSectionWidth}
				/>
			)}
		</Main>
	);
};
